'use client';

import React from 'react';
import SsoLogin from '$modules/onboarding/module-components/sso-login';
const Page = () => {
  return <SsoLogin data-sentry-element="SsoLogin" data-sentry-component="Page" data-sentry-source-file="page.tsx" />;
};
export default Page;